exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard-wrapper.mobile-wrapper{height:100%}.dashboard-wrapper.mobile-wrapper .dashboard.content-wrapper{top:0;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/DashBoardWrapper/DashboardWrapper.scss
// module id = 1861
// module chunks = 0